import React from 'react';
import { PiFileTextLight } from 'react-icons/pi';
import {
  getContractCollaborators,
  addContractCollaborator,
  removeContractCollaborator,
  updateContractCollaboratorAccess,
} from '../contractsApi';
import type { CollaboratorAdapter } from './types';

interface BuildContractAdapterArgs {
  contractUuid: string;
  collaborators: any[];
  currentUserUuid?: string;
  canAdmin?: boolean;
  onUpdate?: () => void;
  subMessage?: string;
}

/**
 * Collaborator adapter for a contract (CLM Phase 3 sharing).
 *
 * Unlike the project/matter adapters, contract sharing is backed directly by
 * `contractsApi` rather than Redux thunks - there is no contract slice. The
 * shared manage-access side panel identifies users by UUID, which the backend
 * resolves to an id, so `addCollaborator` passes the user UUID straight through.
 */
export const buildContractCollaboratorAdapter = ({
  contractUuid,
  collaborators,
  currentUserUuid,
  canAdmin,
  onUpdate,
  subMessage,
}: BuildContractAdapterArgs): CollaboratorAdapter => ({
  resourceUuid: contractUuid,
  resourceType: 'contract',
  collaborators,
  currentUserUuid,
  canAdmin,
  onUpdate,
  addCollaborator: (uuid, userUuid, access) =>
    addContractCollaborator(uuid, userUuid, access as 'view' | 'edit' | 'admin'),
  removeCollaborator: (uuid, collaboratorUuid) =>
    removeContractCollaborator(uuid, collaboratorUuid),
  updateAccess: (uuid, collaboratorUuid, access) =>
    updateContractCollaboratorAccess(uuid, collaboratorUuid, access as 'view' | 'edit' | 'admin'),
  icon: React.createElement(PiFileTextLight, { className: 'w-5 h-5' }),
  subMessage,
});

/** Re-export so detail pages can fetch the current share list. */
export { getContractCollaborators };
